import type { ReactNode } from 'react';
import { Icone, type NomIcone } from './Icone';

export interface EtatVideProps {
  icone: NomIcone;
  titre: ReactNode;
  texte?: ReactNode;
  /** Un seul bouton, qui remplit la zone. */
  action?: ReactNode;
  niveauTitre?: 2 | 3 | 4;
  /** Résulte d'une action de l'utilisateur (recherche, filtre) : annoncé sans déplacer le focus. */
  annonce?: boolean;
  style?: React.CSSProperties;
}

/** Explique pourquoi une zone est vide et propose, s'il y a lieu, l'action qui la remplit. */
export function EtatVide({
  icone,
  titre,
  texte,
  action,
  niveauTitre = 2,
  annonce,
  style,
}: EtatVideProps) {
  const Titre = `h${niveauTitre}` as const;
  return (
    <div className="fc-etat-vide" role={annonce ? 'status' : undefined} style={style}>
      <div className="fc-etat-vide__icone">
        <Icone nom={icone} />
      </div>
      <Titre className="fc-etat-vide__titre">{titre}</Titre>
      {texte && <p className="fc-etat-vide__texte">{texte}</p>}
      {action && <div className="fc-etat-vide__actions">{action}</div>}
    </div>
  );
}
